module.exports = __webpack_public_path__ + "static/media/skull.92ee5820.svg";